import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import SignUp from '../views/SignUp'
import Dashboard from '../views/Dashboard'
import Confirmation from '../views/Confimation'
import Unconfirmed from '../views/Unconfirmed'
import ForgotPassword from '../views/ForgotPassword'

import { Auth } from 'aws-amplify'
import store from '../store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: Confirmation,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/unconfirmed',
      name: 'unconfirmed',
      component: Unconfirmed
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPassword
    }
  ]
})

router.beforeResolve(async (to, from, next) => {
  let user
  // check if we have local user
  if (store.state.signedIn) {
    user = store.state.apopUser
  } else {
    try {
      // check if our token is still good
      user = await Auth.currentAuthenticatedUser()
      await store.dispatch('updateSignedInUser', user)
    } catch (e) {
      // console.log(e)
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    if (user) {
      next({
        path: '/dashboard',
        query: {
          redirect: to.fullPath
        }
      })
    }
  }
  next()
})
export default router
